export default __webpack_public_path__ + "static/media/fallback-img.05c8d691.jpg";